import React, { useEffect, useState } from "react";
import RegisterModal from "./RegisterModal";
import LoginModal from "./LoginModal";

export default (props) => {
  const [whichModal, setWhichModal] = useState("");

  useEffect(() => {
    setWhichModal(props?.modal)
  }, [props?.modal])

  return (
    <>
      {
        whichModal && whichModal === "register" &&
        <RegisterModal open={props.open} handleClose={props.handleClose} phone={props.phone}/>

      }
      {
        whichModal && whichModal === "login" &&
        <LoginModal open={props.open} handleClose={props.handleClose} />
      }
    </>
  );
};
